// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"1d53d434","418":"a1e788ab","444":"07a1156e","538":"7502cfce","614":"2e5d6e5f"}[chunkId] + ".chunk.js";
};